import { Anchor, Card, Container, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { IconBriefcase, IconBuilding, IconLayoutGrid, IconUsers } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useAdminUsersList } from '../../queries/admin-users';
import { useAdminProjectsList } from '../../queries/admin-projects';
import { useCompaniesList } from '../../queries/companies';

export function AdminHub() {
  const { data: users } = useAdminUsersList({ limit: 1 });
  const { data: projects } = useAdminProjectsList({ limit: 1 });
  const { data: companies } = useCompaniesList({ limit: 1 });

  return (
    <Container size="lg">
      <Stack gap="xl">
        <Stack gap={4}>
          <Title order={1}>Admin</Title>
          <Text c="dimmed">Manage users, projects, companies, and global settings.</Text>
        </Stack>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
          <Card withBorder padding="lg">
            <Group gap="sm" mb="xs">
              <IconUsers size={20} />
              <Title order={4}>Users</Title>
            </Group>
            <Text size="sm" c="dimmed" mb="xs">
              Create accounts, manage roles, deactivate.
            </Text>
            {users && (
              <Text size="xs" c="dimmed" mb="md">
                {users.total} total
              </Text>
            )}
            <Anchor component={Link} to="/admin/users">
              Manage users &rarr;
            </Anchor>
          </Card>

          <Card withBorder padding="lg">
            <Group gap="sm" mb="xs">
              <IconBriefcase size={20} />
              <Title order={4}>Projects</Title>
            </Group>
            <Text size="sm" c="dimmed" mb="xs">
              List all projects across tenancy, create new ones.
            </Text>
            {projects && (
              <Text size="xs" c="dimmed" mb="md">
                {projects.total} total
              </Text>
            )}
            <Anchor component={Link} to="/admin/projects">
              Manage projects &rarr;
            </Anchor>
          </Card>

          <Card withBorder padding="lg">
            <Group gap="sm" mb="xs">
              <IconBuilding size={20} />
              <Title order={4}>Companies</Title>
            </Group>
            <Text size="sm" c="dimmed" mb="xs">
              Group projects under a parent company; grant rollup-only viewers.
            </Text>
            {companies && (
              <Text size="xs" c="dimmed" mb="md">
                {companies.total} total
              </Text>
            )}
            <Anchor component={Link} to="/admin/companies">
              Manage companies &rarr;
            </Anchor>
          </Card>

          <Card withBorder padding="lg">
            <Group gap="sm" mb="xs">
              <IconLayoutGrid size={20} />
              <Title order={4}>Form layouts</Title>
            </Group>
            <Text size="sm" c="dimmed" mb="xs">
              Rearrange / resize / regroup the entry-edit, contract-edit, tract-edit, lease-edit,
              well-edit, obligation-edit, and lease-tract-edit forms. Save globally or per project.
            </Text>
            <Stack gap={4}>
              <Anchor component={Link} to="/admin/entry-form-layout" size="sm">
                Entry form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/contract-form-layout" size="sm">
                Contract form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/tract-form-layout" size="sm">
                Tract form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/lease-form-layout" size="sm">
                Lease form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/contract-land-form-layout" size="sm">
                Contract (Land Data) form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/well-form-layout" size="sm">
                Well form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/obligation-form-layout" size="sm">
                Obligation form &rarr;
              </Anchor>
              <Anchor component={Link} to="/admin/lease-tract-form-layout" size="sm">
                Lease tract form &rarr;
              </Anchor>
            </Stack>
          </Card>
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
